/**
 * @generated SignedSource<<32dba57dc5c5a284fa5b46582a44cee9>>
 * @relayHash 239f776c48d72505a2faa3da5e6bf83b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6e166150dee7281832d718ecf24857cad97c709fd7df403621399361bd8013c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DashboardsContentViewRefactoredQuery } from './DashboardsContentViewRefactoredQuery.graphql';

const node: PreloadableConcreteRequest<DashboardsContentViewRefactoredQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e6e166150dee7281832d718ecf24857cad97c709fd7df403621399361bd8013c",
    "metadata": {},
    "name": "DashboardsContentViewRefactoredQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
